import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Flex, Form, Input, Select } from "antd";
import { useWatch } from "antd/es/form/Form";
import React from "react";
import { FormValues } from "../types/FormValues";

type ValueOverwritesListItemProps = {
  onDelete: () => void;
  key: number;
  index: number;
};
const ValueOverwritesListItem = (props: ValueOverwritesListItemProps) => {
  const t = useTranslation();
  const form = Form.useFormInstance<FormValues>();
  const fieldsWatched = useWatch<string[]>(["keys"]);

  const fieldOptions = (fieldsWatched || []).map((field) => ({
    label: field,
    value: field,
  }));
  const style = { margin: 0, flexGrow: 1 };
  return (
    <Flex gap={8} align="flex-end">
      <Form.Item
        label={t("openware:parse.form.overwrites.field.label")}
        name={[props.index, "field"]}
        style={style}
      >
        <Select
          options={fieldOptions}
          onChange={(value) =>
            form.setFieldValue(["valueOverwrites", props.index, "field"], value)
          }
          value={form.getFieldValue(["valueOverwrites", props.index, "field"])}
        />
      </Form.Item>
      <Form.Item
        label={t("openware:parse.form.overwrites.label.label")}
        name={[props.index, "label"]}
        style={style}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("openware:parse.form.overwrites.unit.label")}
        name={[props.index, "unit"]}
        style={style}
      >
        <Input />
      </Form.Item>

      <Button onClick={props.onDelete} danger>
        <Icon icon="fa:trash" />
      </Button>
    </Flex>
  );
};
export default ValueOverwritesListItem;
